/* oxlint-disable no-console */

export type Logger = {
  logError: (error: unknown, extra?: Record<string, unknown>, context?: unknown) => void;
  logWarning: (msg: string, context?: object) => void;
  logInfo: (msg: string, context?: object) => void;
};

export const defaultLogger: Logger = {
  logError: (error) => console.error(error),
  logWarning: (msg, context) => console.warn(msg, ...(context !== undefined ? [context] : [])),
  logInfo: (msg, context) => console.info(msg, ...(context !== undefined ? [context] : [])),
};

let activeLogger: Logger = defaultLogger;

export const configureLogger = (newLogger: Logger): void => {
  activeLogger = newLogger;
};

// Proxy so services import `logger` once and always reach the currently-configured implementation.
// To swap in ss-ui-client's LogService: configureLogger(LogService) at app startup.
export const logger: Logger = {
  logError: (...args) => activeLogger.logError(...args),
  logWarning: (...args) => activeLogger.logWarning(...args),
  logInfo: (...args) => activeLogger.logInfo(...args),
};
